import React from 'react'
import { graphql } from 'gatsby'

import BackgroundImage from 'gatsby-background-image'
import BlockContent from '../components/block-content'
import GraphQLErrorList from '../components/graphql-error-list'
import SEO from '../components/seo'
import Layout from '../containers/layout'

export const query = graphql`
  query DatenschutzPageQuery {
    background: sanityBackgrounds {
     datenschutzPage {
        _key
        _type
        alt
        asset {
          fluid {
            base64
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            sizes
          }
        }
      }
    }

    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
    }
    page: sanityPage(_id: { regex: "/(drafts.|)datenschutz/" }) {
      id
      title
      _rawPortablebody
    }

  }
`

const DatenschutzPage = props => {
  const { data, errors } = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const background = (data || {}).background
  const site = (data || {}).site

  if (!site) {
    throw new Error(
      'Missing "Site settings". Open the studio at http://localhost:3333 and add some content to "Site settings" and restart the development server.'
    )
  }

  const page = data && data.page

  if (!page) {
    throw new Error(
      'Missing "Datenschutz" page data. Open the studio at http://localhost:3333 and add "Datenschutz" page data and restart the development server.'
    )
  }

  return (

    <Layout pageLayout='normal-footer'>

      <SEO title={site.title} description={site.description} keywords={site.keywords} />
      <article className='sections'>
        <section className='page-section white herstellung'>

          <div className='mainImage hero--subpage--datenschutz hero'>
            <BackgroundImage
              Tag='section'
              style={{
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
                backgroundRepeat: 'none',
                display: 'block',
                position: 'fixed',
                height: '100%',
                width: '100%',
                willChange: 'transform'
              }}
              fluid={background.datenschutzPage.asset.fluid}
              backgroundColor={`#040e18`}
              fadeIn={false}
            />
            <div className='content-wrapper herstellung-page'>
              <div className='content'>

                <div className='impressum-sections-wrapper'>

                  <div className='section-wrapper'>
                    <h1>{page.title}</h1>

                    {page._rawPortablebody && <BlockContent blocks={page._rawPortablebody || []} />}
                  </div>

                </div>

              </div>
            </div>
          </div>

        </section>
      </article>

    </Layout>

  )
}

export default DatenschutzPage
